import { useEffect, useState } from "react";
import { get, isFunction, noop } from "lodash";
import { DataTable } from "@circle-react-uikit/DataTableV2";

export const InfiniteQueryDataTable = ({
  children,
  infiniteQuery,
  initialPage = 1,
  onChangePage = noop,
  pageDataPath = "records",
  pageNumberPath = "page",
  totalCountPath = "count",
  ...rest
}: any) => {
  const [pageNumber, setPageNumber] = useState(initialPage ? initialPage : 1);

  useEffect(() => {
    setPageNumber(initialPage);
  }, [initialPage]);

  if (!infiniteQuery) return null;

  const getPageNumber = (page = {}) => get(page, pageNumberPath, -1);
  const getPageData = (page = {}) => get(page, pageDataPath, []);
  const getTotalCount = (page = {}) => get(page, totalCountPath, 0);

  const {
    data = {},
    fetchNextPage,
    fetchPreviousPage,
    isLoading,
    isFetchingNextPage,
    isFetchingPreviousPage = false,
  } = infiniteQuery;

  const { pages = [] } = data;
  const firstPage = pages[0] || {};
  const totalRecordsCount = getTotalCount(firstPage);
  const currentPage = pages.find(
    (page: any) => getPageNumber(page) === pageNumber,
  );
  const currentPageData = getPageData(currentPage);

  const handleChangedPage = (newPage: number) => {
    const alreadyFetched = pages.some(
      (page: any) => getPageNumber(page) === newPage,
    );

    if (newPage > pageNumber && !alreadyFetched) {
      fetchNextPage();
    } else if (newPage < pageNumber && !alreadyFetched && fetchPreviousPage) {
      fetchPreviousPage();
    }

    setPageNumber(newPage);

    if (isFunction(onChangePage)) {
      onChangePage(newPage);
    }
  };

  return (
    <DataTable
      data={currentPageData}
      totalRecordsCount={totalRecordsCount}
      isLoading={isLoading || isFetchingNextPage || isFetchingPreviousPage}
      initialPage={initialPage}
      onChangePage={handleChangedPage}
      {...rest}
    >
      {children}
    </DataTable>
  );
};
